import * as React from 'react'

export const SevenDayCalendarIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4 1.5C4 0.96875 4.4375 0.5 5 0.5C5.53125 0.5 6 0.96875 6 1.5V2.5H10V1.5C10 0.96875 10.4375 0.5 11 0.5C11.5312 0.5 12 0.96875 12 1.5V2.5H13.5C14.3125 2.5 15 3.1875 15 4V5.5H1V4C1 3.1875 1.65625 2.5 2.5 2.5H4V1.5ZM15 6.5V15C15 15.8438 14.3125 16.5 13.5 16.5H2.5C1.65625 16.5 1 15.8438 1 15V6.5H15ZM5 9.5C5 8.96875 4.53125 8.5 4 8.5C3.4375 8.5 3 8.96875 3 9.5C3 10.0625 3.4375 10.5 4 10.5C4.53125 10.5 5 10.0625 5 9.5ZM12 14.5C12.5312 14.5 13 14.0625 13 13.5C13 12.9688 12.5312 12.5 12 12.5C11.4375 12.5 11 12.9688 11 13.5C11 14.0625 11.4375 14.5 12 14.5ZM7 9.5C7 9.9375 7.3125 10.25 7.75 10.25H12.25C12.6562 10.25 13 9.9375 13 9.5C13 9.09375 12.6562 8.75 12.25 8.75H7.75C7.3125 8.75 7 9.09375 7 9.5ZM8.25 12.75H3.75C3.3125 12.75 3 13.0938 3 13.5C3 13.9375 3.3125 14.25 3.75 14.25H8.25C8.65625 14.25 9 13.9375 9 13.5C9 13.0938 8.65625 12.75 8.25 12.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
